import PriceTotal from './PriceTotal.vue'
export default PriceTotal